export const SUPPORT_CONTACT = {
  email: "venugopala11000@gmail.com",
  phone: "8495030355",
};
